var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2390_1324)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2390_1324)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6486 27.875C28.2208 25.4065 26.0205 23.6365 23.4527 22.7975C24.7229 22.0414 25.7097 20.8892 26.2617 19.5179C26.8136 18.1467 26.9002 16.6321 26.5081 15.2069C26.116 13.7817 25.2668 12.5245 24.0911 11.6286C22.9154 10.7327 21.4781 10.2474 19.9999 10.2474C18.5217 10.2474 17.0844 10.7327 15.9087 11.6286C14.7329 12.5245 13.8838 13.7817 13.4917 15.2069C13.0996 16.6321 13.1862 18.1467 13.7381 19.5179C14.2901 20.8892 15.2769 22.0414 16.5471 22.7975C13.9793 23.6356 11.779 25.4056 10.3511 27.875C10.2988 27.9604 10.264 28.0554 10.249 28.1544C10.2339 28.2534 10.2389 28.3544 10.2635 28.4515C10.2881 28.5486 10.332 28.6397 10.3924 28.7196C10.4528 28.7995 10.5286 28.8664 10.6153 28.9165C10.7021 28.9666 10.798 28.9988 10.8973 29.0113C10.9967 29.0237 11.0976 29.0161 11.194 28.989C11.2904 28.9618 11.3803 28.9156 11.4586 28.8531C11.5368 28.7906 11.6018 28.713 11.6496 28.625C13.4158 25.5725 16.5377 23.75 19.9999 23.75C23.4621 23.75 26.584 25.5725 28.3502 28.625C28.398 28.713 28.4629 28.7906 28.5412 28.8531C28.6194 28.9156 28.7094 28.9618 28.8058 28.989C28.9022 29.0161 29.0031 29.0237 29.1024 29.0113C29.2018 28.9988 29.2977 28.9666 29.3844 28.9165C29.4712 28.8664 29.547 28.7995 29.6074 28.7196C29.6678 28.6397 29.7116 28.5486 29.7363 28.4515C29.7609 28.3544 29.7658 28.2534 29.7508 28.1544C29.7357 28.0554 29.701 27.9604 29.6486 27.875ZM14.7499 17C14.7499 15.9616 15.0578 14.9466 15.6347 14.0832C16.2115 13.2199 17.0315 12.547 17.9908 12.1496C18.9501 11.7523 20.0057 11.6483 21.0241 11.8509C22.0425 12.0534 22.978 12.5535 23.7122 13.2877C24.4464 14.0219 24.9464 14.9574 25.149 15.9758C25.3516 16.9942 25.2476 18.0498 24.8503 19.0091C24.4529 19.9684 23.78 20.7883 22.9166 21.3652C22.0533 21.9421 21.0382 22.25 19.9999 22.25C18.608 22.2485 17.2735 21.6949 16.2892 20.7107C15.305 19.7264 14.7514 18.3919 14.7499 17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2390_1324",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAFF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#FCFF4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#E788FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8989"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2390_1324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b4700c5931878907ef6557e0c350812a.svg";
export { ForwardRef as ReactComponent };